export const contacts = {
list: {
  count_other: "{{count}} contactos",
  count_many: "{{count}} contactos",
  count_one: "{{count}} contacto",
  csv: {
    scope: "Quién lo ve",
    organisation: "Organización",
    phone: "Teléfono",
    email: "Correo electrónico",
    roles: "Funciones",
    displayName: "Nombre visible",
  },
  insight: {
    signalOrgs_other: "A {{count}} organizaciones les faltan datos.",
    signalOrgs_many: "A {{count}} organizaciones les faltan datos.",
    signalOrgs_one: "A {{count}} organización le faltan datos.",
    signalSkills_other: "{{count}} contratistas no tienen habilidades etiquetadas.",
    signalSkills_many: "{{count}} contratistas no tienen habilidades etiquetadas.",
    signalSkills_one: "{{count}} contratista no tiene habilidades etiquetadas.",
    signalVisible_other: "{{count}} contactos coinciden con esta vista.",
    signalVisible_many: "{{count}} contactos coinciden con esta vista.",
    signalVisible_one: "{{count}} contacto coincide con esta vista.",
    summaryMissing_other: "{{count}} contactos no tienen correo ni teléfono.",
    summaryMissing_many: "{{count}} contactos no tienen correo ni teléfono.",
    summaryMissing_one: "{{count}} contacto no tiene correo ni teléfono.",
    source: "los contactos que puedes ver",
    metricSkillGaps: "Sin habilidades",
    metricMissingReach: "Sin correo ni teléfono",
    metricVisible: "Mostrados",
    signalOrgsOk: "A ninguna organización le faltan datos.",
    signalSkillsOk: "Los contratistas mostrados tienen habilidades etiquetadas.",
    summaryOk: "Todos los contactos mostrados tienen correo o teléfono.",
    actionOrgs: "Completa las fichas de las organizaciones antes de exportar o crear informes.",
    actionSkills: "Etiqueta las habilidades de los contratistas para que se sugiera el más adecuado para cada trabajo.",
    actionReach: "Añade un correo o un teléfono a los contactos a los que das trabajo.",
  },
  historySummary: "Trabajo relacionado, notas y enlaces del directorio",
  untitledJob: "Orden de trabajo sin título",
  noLinkedSkills: "Aún sin habilidades",
  noRolesAssigned: "Aún sin roles",
  independentContact: "Contacto independiente",
  kindInternal: "Interno",
  noSkillMatches: "Ninguna habilidad coincide.",
  searchSkills: "Buscar habilidades…",
  showingA11y: "Mostrando: {{role}}. Cambiar filtro",
  roleAll: "Todos",
  noContacts: "Sin contactos",
  purpose: "Personas externas: contratistas, proveedores y clientes",
  showMeHow: "Muéstrame cómo",
  clearFilters: "Borrar filtros",
  addContractor: "Añadir contratista",
title: "Contactos",
addContact: "Añadir contacto",
loading: "Cargando…",
emptyFilteredTitle: "No hay contactos coincidentes",
loadFailedTitle: "No hemos podido cargar tus contactos",
loadUnavailableTitle: "Los contactos no están disponibles",
emptyTitle: "Aún no hay contactos",
emptyFilteredSubtitle: "Nada coincide con estos filtros. Toca Borrar filtros para ver a todos.",
emptyContractorsTitle: "Aún no hay contratistas",
emptyContractorsSubtitle: "Añade un contratista para darle trabajos o pedirle presupuestos.",
visibilityGroupA11y: "Quién puede verlos",
visibilityChip: {
  all: "Todos",
  team: "Solo el equipo",
  account: "Todo el espacio de trabajo",
},
emptySubtitle: "Añade las personas y empresas con las que trabajas. A los contratistas que añadas puedes darles trabajos y pedirles presupuestos.",
importLabel: "Importar",
},
shared: {
kindLabel: "Tipo de contacto",
kind: {
person: "Persona",
organisation: "Organización",
},
visibility: {
team: "Solo mi equipo",
account: "Todos en mi empresa",
},
role: {
contractor: "Contratista",
landlord: "Arrendador",
owner: "Propietario",
client: "Cliente",
agent_broker: "Agente / intermediario",
tenant: "Inquilino",
supplier: "Proveedor",
inspector: "Inspector",
occupant: "Ocupante",
driver: "Conductor",
fleet_manager: "Gestor de flota",
operator: "Operador",
engineer: "Ingeniero",
technician: "Técnico",
other: "Otro",
},
roleGroup: {
general: "General",
property: "Propiedad",
fleet: "Flota",
equipment: "Equipo",
},
roleDescription: {
contractor: "Puede recibir trabajo, solicitudes de presupuesto y actualizaciones de trabajos.",
landlord: "Representa al propietario o al grupo propietario del inmueble.",
owner: "Es propietario del activo o cartera al que está vinculado este contacto.",
client: "Solicita trabajo, revisa hallazgos o aprueba reparaciones.",
agent_broker: "Actúa en nombre del propietario, cliente o inquilino.",
tenant: "Ocupa o utiliza el activo y puede informar de problemas.",
supplier: "Proporciona materiales, piezas o servicios especializados.",
inspector: "Realiza inspecciones, revisiones o comprobaciones de cumplimiento.",
occupant: "Vive en, usa o está asignado al activo.",
driver: "Conduce o está asignado a un vehículo de la flota.",
fleet_manager: "Gestiona vehículos, conductores y operaciones de flota.",
operator: "Opera o está asignado a un equipo.",
engineer: "Mantiene, revisa o repara equipos.",
technician: "Servicio técnico práctico, pruebas o reparaciones en equipos.",
other: "Úsalo cuando ningún otro rol se ajuste.",
},
primaryToggle: {
primary: "Principal",
makePrimary: "Hacer principal",
},
phoneType: {
mobile: "Móvil",
work: "Trabajo",
home: "Casa",
other: "Otro",
},
},
create: {
  contractorEmailHint: "Los contratistas necesitan un correo: los trabajos y las solicitudes de presupuesto se envían ahí.",
  headerSubtitleContractor: "Alguien ajeno a tu equipo a quien puedes dar trabajos o pedir presupuestos.",
  headerTitleContractor: "Nuevo contratista",
  visibilityEveryone: "Todos en tu empresa pueden ver este contacto.",
headerTitle: "Nuevo contacto",
headerSubtitle: "Añade una persona u organización al directorio de tu cuenta.",
unnamedFallback: "Contacto sin nombre",
roleSummary: "{{role}} - {{description}}",
a11y: {
person: "El contacto es una persona",
organisation: "El contacto es una organización",
},
alerts: {
  contractorEmailRequired: "Añade su correo para que reciba trabajos y solicitudes de presupuesto.",
  contractorEmailTitle: "Añade su correo",
  createFailedTitle: "No se pudo añadir el contacto",
required: "Introduce un nombre, un correo o un teléfono.",
noAccountTitle: "Cuenta no disponible",
noAccountBody: "Únete a una cuenta o crea una antes de añadir contactos.",
createFailed: "No pudimos añadir este contacto. Inténtalo de nuevo en un momento.",
emailNeededTitle: "Se necesita un correo para compartir",
emailNeededBody: "Añada un correo electrónico válido: así es como este contacto recibe el activo compartido.",
invalidPhoneTitle: "Revise el número de teléfono",
invalidPhoneBody: "Introduzca un número válido para el país seleccionado o deje el teléfono vacío.",
},
sections: {
basicIdentityTitle: "Identidad básica",
basicIdentityHelper: "Quién es este contacto y cómo debe aparecer en tu directorio.",
contactInfoTitle: "Información de contacto",
contactInfoHelper: "Cómo puede tu equipo ponerse en contacto con él.",
whoIsThisTitle: "¿Quién es?",
whoIsThisHelper: "Elige si estás añadiendo una persona o una organización.",
contactMethodTitle: "¿Cómo lo contactamos?",
contactMethodHelper: "Añade el mejor correo electrónico y número de teléfono para el seguimiento.",
rolesWideTitle: "Roles y tipos",
rolesWideHelper: "Selecciona todos los roles que se apliquen a este contacto.",
visibilityWideTitle: "Visibilidad",
visibilityWideHelper: "Elige quién puede ver y usar este contacto.",
rolesTitle: "Roles",
rolesHelper: "Selecciona todos los roles que se apliquen a este contacto.",
visibilityTitle: "Visibilidad",
visibilityHelper: "Elige quién puede ver y usar este contacto.",
detailsWideTitle: "Detalles adicionales",
skillsTitle: "Competencias",
skillsHelper: "Las competencias determinan a qué trabajos se puede asignar este contacto y a quién se sugiere para ellos.",
detailsTitle: "Detalles adicionales",
detailsHelper: "Detalles comerciales opcionales.",
},
labels: {
displayName: "Nombre visible",
organisation: "Nombre de la organización",
organisations: "Organizaciones",
company: "Empresa",
email: "Correo electrónico",
phone: "Teléfono",
companyRegistrationNumber: "Número de registro de la empresa",
vatTaxNumber: "NIF / número de identificación fiscal",
notes: "Notas",
skills: "Competencias",
},
placeholders: {
displayName: "p. ej. Alex Inspector",
organisation: "p. ej. Grupo Inmobiliario Northside",
company: "p. ej. Servicios Northside",
companyShort: "Nombre de empresa opcional",
email: "nombre@ejemplo.com",
phone: "Mejor número de contacto",
companyRegistrationNumber: "Número de registro (opcional)",
vatTaxNumber: "NIF o número de identificación fiscal (opcional)",
notes: "Notas privadas",
},
visibility: {
team: "Solo mi equipo",
account: "Todos en mi empresa",
},
skillsPicker: {
title: "Competencias del contacto",
hint: "Elige competencias del catálogo de tu cuenta. Aparecen en el contacto y en los filtros.",
},
actions: {
saving: "Guardando...",
submit: "Añadir contacto",
submitContractor: "Añadir contratista",
dictate: "Dictar",
stopDictation: "Detener",
},
title: "Añadir contacto",
addedAs: "Agregado como",
nameLabel: "Nombre",
namePlaceholder: "Nombre completo",
emailLabel: "Correo electrónico",
saveAndUse: "Agregar y usar contacto",
quickCreate: {
  duplicateReason: {
    name: "Mismo nombre",
    phone: "Mismo número de teléfono",
    email: "Mismo correo electrónico",
  },
closeA11y: "Cerrar la ventana para añadir contacto",
requiredToShareSuffix: " · requerido para compartir",
reviewPossibleMatch: "Revisar posible coincidencia",
discardTitle: "¿Descartar este contacto?",
discardBody: "Ha ingresado datos de contacto que aún no se han guardado.",
keepEditing: "Sigue editando",
discard: "Descartar",
duplicateHeading: "Posible contacto existente",
duplicateHint: "Reutilizar una identidad existente cuando sea la misma persona. La creación de un registro separado nunca fusiona datos automáticamente.",
useExisting: "Usar existente",
useExistingA11y: "Usar el contacto existente {{name}}",
createSeparate: "Crear un contacto separado",
createSeparateA11y: "Crear un contacto separado después de revisar los duplicados",
},
},
card: {
noDetails: "Sin datos de contacto",
invitedNotJoined: "Invitado · aún no se ha unido",
email: "Correo",
call: "Llamar",
emailA11y: "Enviar correo a {{name}}",
callA11y: "Llamar a {{name}}",
roles: "Roles",
skills: "Habilidades",
none: "Ninguno",
unlink: "Desvincular a {{name}}",
accessChange: "Acceso: {{label}}. Cambiar",
access: {
requester: "Puede solicitar",
viewer: "Puede ver",
none: "Sin acceso",
},
},
shareEdit: {
sendInvite: "Enviar invitación",
resendInvite: "Reenviar invitación",
sending: "Enviando…",
removeAccess: "Quitar acceso",
},
detail: {
  inviterFallback: "Alguien con quien trabajas",
  noRolesYet: "Aún sin rol. Toca Editar y elige Contratista para darle trabajos.",
  inviteNeedsEmail: "Añade un correo electrónico para invitar a {{name}}.",
  resendFailed: "No se pudo reenviar la invitación. Inténtalo de nuevo en un momento.",
title: "Contacto",
loadingMessage: "Cargando datos de contacto...",
noContactSelected: "Ningún contacto seleccionado",
contactNotFound: "Contacto no encontrado",
loadFailedTitle: "No pudimos cargar este contacto",
loadUnavailableTitle: "No se puede mostrar este contacto",
goBack: "Volver",
scopeTeamOnly: "Solo mi equipo",
sectionOverview: "Resumen",
sectionRoles: "Roles",
sectionContactDetails: "Datos de contacto",
sectionInvitations: "Invitaciones y acceso",
sectionVisibility: "Visibilidad",
sectionTeamAccess: "Acceso del equipo",
sectionSkills: "Competencias",
sectionHistory: "Historial",
labelType: "Tipo",
labelName: "Nombre",
labelOrganisation: "Organización",
labelCompany: "Empresa",
labelCompanyRegistrationNumber: "Número de registro de la empresa",
labelVatTaxNumber: "NIF / número de identificación fiscal",
labelStatus: "Estado",
labelEmail: "Correo electrónico",
labelPhone: "Teléfono",
labelAudience: "Audiencia",
labelOwningTeam: "Equipo propietario",
statusArchived: "Archivado",
statusActive: "Activo",
noEmailOrPhone: "Sin correo electrónico ni teléfono",
visibleToAllTeams: "Todos en tu empresa pueden ver este contacto.",
noSkillsAssigned: "No hay habilidades asignadas. Edite el contacto para agregar etiquetas de su catálogo de habilidades.",
joinedApp: "Este contacto se ha unido a la aplicación.",
pendingInvites: "Invitaciones pendientes: pueden utilizar el enlace para iniciar sesión",
noInvitesYet: "Aún no hay invitaciones",
inviteSent: "Enviada el {{date}}",
inviteExpires: "Expira {{date}}",
inviteStatus: {
pending: "pendiente",
accepted: "aceptada",
revoked: "revocada",
expired: "caducada",
},
resend: "Reenviar",
revoke: "Revocar",
revokeInviteTitle: "Revocar invitación",
revokeInviteMessage: "Esto cancelará la invitación.",
cancel: "Cancelar",
edit: "Editar",
editContactA11y: "Editar contacto",
contactAlreadyInApp: "Contacto ya en la aplicación",
inviteContactToAppA11y: "Invitar contacto a la aplicación",
alreadyInApp: "Ya en la aplicación",
inviteToApp: "Invitar a la aplicación",
invite: "Invitar",
share: "Compartir",
shareWithTeam: "Compartir con el equipo",
shareContactWithTeamA11y: "Compartir contacto con el equipo",
shareContactWithAnotherTeamA11y: "Compartir contacto con otro equipo",
promote: "Compartir con todos los equipos",
promoteToAccount: "Compartir con todos los equipos",
promoteContactToAccountA11y: "Compartir este contacto con todos los equipos",
promoteContactVisibilityA11y: "Compartir este contacto con todos los equipos",
archiveContact: "Archivar contacto",
archive: "Archivar",
backToContactsListA11y: "Volver a la lista de contactos",
contactsBreadcrumb: "Contactos",
noOtherTeamsTitle: "Ningún otro equipo",
noOtherTeamsBody: "No hay otros equipos con quienes compartir este contacto.",
sharedTitle: "Compartido",
sharedBody: "Contacto compartido con {{team}}.",
fallbackTeam: "equipo",
errorTitle: "No ha funcionado",
failedToShare: "No se pudo compartir el contacto. Inténtalo de nuevo en un momento.",
promoteToAccountBody: "Todos en tu empresa podrán ver este contacto.",
doneTitle: "Hecho",
promotedBody: "Ahora todos en tu empresa pueden ver este contacto.",
failedToPromote: "No se pudo compartir el contacto con todos los equipos. Inténtalo de nuevo en un momento.",
invitationSentTitle: "Invitación enviada",
invitationSentBody: "Se envió un correo electrónico a {{email}}.",
invitationCreatedTitle: "Invitación guardada, correo no enviado",
invitationCreatedBody: "Guardamos la invitación para {{email}}, pero no pudimos enviarla por correo. Toca Reenviar para intentarlo de nuevo.",
failedToCreateInvite: "No se pudo crear la invitación. Inténtalo de nuevo en un momento.",
archiveContactTitle: "Archivar contacto",
archiveContactBody: "Este contacto estará oculto de las listas. Puede restaurar más tarde si es necesario.",
failedToArchive: "No se pudo archivar el contacto. Inténtalo de nuevo en un momento.",
invitesEmailResent: "Enviado",
invitesEmailResentBody: "Correo de invitación reenviado.",
inviteLinkUpdatedTitle: "Correo no enviado",
inviteLinkUpdatedBody: "No pudimos enviar la invitación por correo. Toca Reenviar para intentarlo de nuevo en un momento.",
timelineLoadingTitle: "Cargando actividad de contacto",
timelineErrorTitle: "La actividad está incompleta",
timelineEmptyTitle: "Aún no hay actividad",
timelineLoadingSubtitle: "Recuperando el trabajo y el historial vinculados.",
timelineErrorSubtitle: "No se pudieron cargar algunos registros vinculados. Vuelva a intentar el trabajo vinculado arriba.",
timelineEmptySubtitle: "Los accesos compartidos, solicitudes, inspecciones, órdenes de trabajo e invitaciones relacionados con {{name}} aparecerán aquí.",
accessLevel: {
view: "Ver",
edit: "Editar",
manage: "Gestionar",
},
},
edit: {
pageTitle: "Editar contacto",
noContactId: "Sin identificación de contacto",
contactNotFound: "Contacto no encontrado",
back: "Atrás",
kindA11yPerson: "Tipo de contacto: persona",
kindA11yOrganisation: "Tipo de contacto: organización",
basicIdentityHelperWide: "Persona u organización. Se requiere el nombre para mostrar (o nombre y apellido).",
displayNameLabel: "Nombre para mostrar *",
displayNamePlaceholder: "Nombre mostrado en listas",
displayNameA11yWide: "Nombre para mostrar, obligatorio",
displayNameA11yNarrow: "Nombre para mostrar (obligatorio)",
firstNameLabel: "Nombre",
firstNamePlaceholder: "Nombre",
lastNameLabel: "Apellidos",
lastNamePlaceholder: "Apellidos",
organisationsLabel: "Organizaciones",
contactInfoHelper: "Se utiliza para invitaciones y seguimiento.",
emailLabel: "Correo electrónico",
emailPlaceholder: "correo@ejemplo.com",
emailA11yWide: "Dirección de correo electrónico",
phoneLabel: "Teléfono",
whoIsThisHelperNarrow: "Persona u organización. El nombre es obligatorio; la organización ayuda con el contexto.",
contactMethodHelperNarrow: "El correo electrónico o el teléfono le ayudarán a comunicarse con ellos más tarde.",
rolesTitleWide: "Funciones y tipos",
rolesTitleNarrow: "¿Qué son para nosotros?",
rolesHelper: "Elige uno o más roles para que este contacto aparezca en los flujos correctos.",
visibilityHelperWide: "Solo mi equipo: solo tu equipo ve este contacto. Todos en mi empresa: todos los equipos lo ven.",
visibilityTitleNarrow: "¿Quién puede usar este contacto?",
visibilityHelperNarrow: "Solo lo ve tu equipo, salvo que elijas Todos en mi empresa. Puedes compartirlo con todos los equipos más adelante.",
visibilityA11yTeam: "Visibilidad: solo mi equipo",
visibilityA11yAccount: "Visibilidad: todos en mi empresa",
vatA11y: "Número de IVA o impuesto",
notesTitleWide: "Notas",
notesTitleNarrow: "Detalles opcionales",
notesHelper: "Las notas son privadas para su equipo.",
improving: "Mejorando...",
improveWithAi: "Mejorar con IA",
addNotesFirstTitle: "Agregar notas primero",
addNotesFirstBody: "Escriba o dicte un borrador breve y luego utilice Mejorar con IA.",
unableToImproveNotesTitle: "No se pueden mejorar las notas",
improveNotesFailed: "No se pudieron mejorar las notas. Por favor inténtalo de nuevo.",
tidiedNotesTitle: "Notas ordenadas",
tidiedNotesRationale: "Revise las notas ordenadas antes de aplicarlas.",
saveChanges: "Guardar cambios",
saving: "Guardando…",
requiredTitle: "Obligatorio",
requiredNameBody: "Introduzca un nombre: nombre para mostrar o nombre y apellido, o nombre de la organización.",
workspaceChangedError: "Su espacio de trabajo cambió. Vuelva a abrir el contacto antes de continuar.",
updateFailed: "No se pudieron guardar los cambios. Inténtalo de nuevo en un momento.",
},
import: {
  actions: {
    addManually: "Añadir manualmente",
    phonePicker: "Selector del teléfono",
    uploadFile: "Subir un archivo",
  },
  access: {
    whyLine: "AssetWRX solo lee tus contactos para que elijas a quién añadir.",
    deniedTitle: "El acceso a contactos está desactivado",
    deniedBody: "Permite el acceso para ver aquí los contactos de tu teléfono. Puedes seguir añadiendo personas manualmente o con el selector del teléfono.",
    allow: "Permitir acceso",
    openSettings: "Abrir ajustes",
    limited: "Solo has compartido algunos contactos con AssetWRX. Usa el selector del teléfono para añadir a los demás.",
    unavailableTitle: "Los contactos de tu teléfono no están disponibles aquí",
    unavailableBody: "La importación desde contactos funciona en la app de iOS y Android. Aquí puedes añadir personas manualmente o subir un archivo.",
  },
  list: {
    searchA11y: "Buscar contactos",
    searchPlaceholder: "Buscar nombre, empresa, correo o teléfono",
    count_one: "{{count}} contacto en este teléfono",
    count_many: "{{count}} contactos en este teléfono",
    count_other: "{{count}} contactos en este teléfono",
    loading: "Cargando tus contactos…",
    emptyTitle: "No hay contactos en este teléfono",
    emptyBody: "Añade personas manualmente, o usa el selector del teléfono si tus contactos están en otra app.",
    noMatchTitle: "Nadie coincide con «{{query}}»",
    noMatchBody: "Revisa la ortografía, o busca por empresa, correo o teléfono.",
    alreadyAdded: "Ya está en AssetWRX",
    reviewA11y: "Revisar a {{name}} antes de añadir",
    selectA11y: "Seleccionar a {{name}}",
    selectAll: "Seleccionar todo ({{total}})",
    clearSelection: "Quitar selección",
    import: "Importar",
    importCount_one: "Importar {{count}}",
    importCount_many: "Importar {{count}}",
    importCount_other: "Importar {{count}}",
  },
  confirm: {
    title_one: "Añadir {{count}} contacto",
    title_many: "Añadir {{count}} contactos",
    title_other: "Añadir {{count}} contactos",
    subtitle: "Desde los contactos de tu teléfono",
    alreadyNote_one: "{{count}} ya está en AssetWRX y se añadirá de nuevo.",
    alreadyNote_many: "{{count}} ya están en AssetWRX y se añadirán de nuevo.",
    alreadyNote_other: "{{count}} ya están en AssetWRX y se añadirán de nuevo.",
    roleLabel: "Rol",
    roleHelper: "Opcional. Se aplica a todas las personas que añadas y puedes cambiarlo después.",
    visibilityLabel: "Quién puede verlos",
    privacy: "Añade solo a personas con las que trabajas. Serán visibles para {{audience}}.",
    audienceTeam: "tu equipo",
    audienceAccount: "toda tu empresa",
    cancel: "Cancelar",
    confirm_one: "Añadir {{count}}",
    confirm_many: "Añadir {{count}}",
    confirm_other: "Añadir {{count}}",
    progress: "Añadiendo {{done}} de {{total}}…",
    closeA11y: "Cerrar",
  },
  notes: {
    jobTitle: "Cargo: {{value}}",
    otherEmails: "Otros correos: {{value}}",
  },
  alerts: {
    readFailedTitle: "No se pudieron leer los contactos",
    readFailedDefaultBody: "Inténtalo de nuevo, o usa el selector del teléfono para añadir personas una a una.",
    pickerFailedTitle: "No se pudo abrir el selector de contactos",
    pickerFailedDefaultBody: "Conceda acceso a los contactos en Configuración y vuelva a intentarlo.",
    invalidContactTitle: "Contacto no válido",
    invalidContactBody: "Este contacto no tiene información utilizable. Por favor seleccione otro.",
    noAccountTitle: "Sin cuenta",
    noAccountBody: "Debes estar en una cuenta para agregar contactos.",
    stoppedTitle: "Importación detenida",
    stoppedWithProgress: "Se agregó {{count}} antes de un error: {{error}}",
    unknownError: "Error desconocido",
    completeBody_one: "Se agregó {{count}} contacto.",
    completeBody_other: "Se agregaron {{count}} contactos.",
    completeBody_many: "Se agregaron {{count}} contactos.",
  },
  review: {
    requiredTitle: "Obligatorio",
    requiredBody: "Introduzca un nombre.",
    errorTitle: "Error",
    errorDefaultBody: "No se pudo crear contacto.",
    noContactSelected: "Ningún contacto seleccionado. Regrese y elija uno desde su teléfono.",
    backToContacts: "Volver a contactos",
    nameSectionTitle: "Nombre *",
    nameA11y: "Nombre (obligatorio)",
    namePlaceholder: "Nombre para mostrar",
    companyA11y: "Empresa (opcional)",
    companyPlaceholder: "Empresa (opcional)",
    notesA11y: "Notas (opcional)",
    notesPlaceholder: "Notas privadas (opcional)",
    visibilitySectionTitle: "¿Quién puede usar este contacto?",
    skillsSectionTitle: "Competencias",
    skillsPickerHint: "Opcional: adjunte habilidades de catálogo a este contacto importado.",
    nameLabel: "Nombre",
    companyLabel: "Empresa",
    notesLabel: "Notas",
    rolesSectionTitle: "Rol",
    moreDetails: "Más detalles",
    fewerDetails: "Menos detalles",
    extraPhones_one: "También añade {{count}} número más: {{numbers}}",
    extraPhones_many: "También añade {{count}} números más: {{numbers}}",
    extraPhones_other: "También añade {{count}} números más: {{numbers}}",
    existingTitle: "Ya está en AssetWRX como {{name}}",
    existingOpen: "Abrir",
    save: "Guardar",
    saveAndAnother: "Guardar y añadir otro",
    addedToast: "{{name}} añadido",
  },
},
picker: {
  createNamed: "Crear «{{search}}»",
defaultTitle: "Seleccionar contacto",
closeA11y: "Cerrar el selector de contactos",
searchPlaceholder: "Buscar nombre, empresa, correo electrónico o rol...",
searchA11y: "Buscar contactos",
scope: {
all: "Todos",
team: "Solo el equipo",
account: "Todo el espacio de trabajo",
},
sections: {
recommended: "Recomendado para este trabajo",
recent: "Recientes",
searchResults: "Resultados de la búsqueda",
allContacts: "Todos los contactos",
},
searching: "Buscando…",
empty: {
  noMatch: "Aún no hay nadie llamado «{{search}}».",
  noneNoCreate: "Aún no hay contactos.",
  none: "Aún no hay contactos. Toca {{label}}.",
skillsScoped: "Ningún contacto {{scope}} coincide con estas habilidades. Mostrar todos los contactos o desactivar un filtro de habilidades.",
searchScoped: "Ningún contacto {{scope}} coincide con tu búsqueda. Muestra todos los contactos o prueba con otro nombre.",
idleScoped: "Aún no hay contactos compartidos con {{scope}}. Muestra todos los contactos o añade uno.",
skills: "Ningún contacto coincide con estas habilidades. Desactive un filtro de habilidades o busque por nombre.",
search: "Ningún contacto coincide.",
idle: "Escriba para buscar contactos.",
},
showAllContacts: "Mostrar todos los contactos",
clearScopeA11y: "Borra el filtro {{scope}} y muestra todos los contactos.",
deselectA11y: "Deseleccionar {{name}}",
selectA11y: "Seleccione {{name}}",
selectWithRolesA11y: "Seleccione {{name}}, roles {{roles}}",
recommendedReason: "Recomendado · {{reason}}",
workspaceWide: "Todo el mundo",
teamOnly: "Solo mi equipo",
skillsLabel: "Competencias",
clear: "Borrar",
clearSkillFiltersA11y: "Borrar filtros de habilidades",
addFilter: "Añadir filtro",
hide: "Ocultar",
hideSkillListA11y: "Ocultar lista de filtros de habilidades",
addSkillFiltersA11y: "Agregar filtros de habilidades",
skillFilterHint: "Opcional: filtrar contactos por una o más habilidades.",
removeSkillFilterA11y: "Quitar el filtro {{skill}}",
fromThisJob: "De esta orden de trabajo",
filterBySkillA11y: "Filtrar por {{skill}}",
searchSkillsPlaceholder: "Buscar habilidades...",
searchSkillsA11y: "Buscar habilidades",
noSkillsMatch: "Ninguna habilidad coincide con tu búsqueda.",
addAction: "Agregar",
removeAction: "Quitar",
toggleSkillFilterA11y: "{{action}} el filtro {{skill}}",
selectedCount_one: "{{count}} seleccionado",
selectedCount_many: "{{count}} seleccionados",
selectedCount_other: "{{count}} seleccionados",
continueLabel: "Continuar",
continueWithA11y: "Continuar con {{count}} {{noun}}",
contactNoun_one: "contacto",
contactNoun_other: "contactos",
contactNoun_many: "contactos",
},
organisationsField: {
empty: "Aún no hay organizaciones vinculadas.",
chooseOrganisation: "Elige organización",
primaryA11y: "Organización principal",
removeA11y: "Eliminar organización",
titlePlaceholder: "Cargo (p. ej., responsable de fiabilidad)",
titleA11y: "Cargo en la organización",
addA11y: "Agregar organización",
addLabel: "Agregar organización",
pickerTitle: "Seleccionar organización",
},
phonesField: {
empty: "Aún no hay números de teléfono.",
phoneTypeA11y: "Tipo de teléfono {{label}}",
primaryA11y: "Teléfono principal",
removeA11y: "Quitar teléfono",
addA11y: "Agregar número de teléfono",
addLabel: "Agregar teléfono",
},
threeSixty: {
assetSharedTitle: "{{asset}} compartido con {{name}}",
shareSubtitle: "Acceso compartido · {{status}}",
requestSubtitle: "Solicitud · {{status}}",
jobFallback: "Orden de trabajo",
inspectionLabel: "Inspección",
contactJoinedTitle: "{{name}} se unió a la aplicación",
invitedTitle: "Invitado a la aplicación ({{email}})",
invitationSubtitle: "Invitación · {{status}}",
appStandingInApp: "En la aplicación",
appStandingPending: "Invitación pendiente desde {{when}}",
appStandingNotInvited: "Aún no invitado",
statusActive: "Activa",
lastActivity: "Última actividad {{when}}",
noActivityYet: "Aún no hay actividad",
noEmailOrPhone: "No hay correo electrónico ni teléfono registrados.",
emailA11y: "Correo electrónico {{email}}",
callA11y: "Llamar a {{phone}}",
openWork: {
sharedAssets: "Activos compartidos",
openRequests: "Solicitudes abiertas",
openInspections: "Inspecciones abiertas",
openJobs: "Órdenes de trabajo abiertas",
},
openWorkInfo: {
sharedAssetsDesc: "Activos que este contacto puede ver y sobre los que puede generar solicitudes mediante un acceso compartido activo.",
sharedAssetsBasedOn: "{{active}} de {{total}} accesos compartidos siguen activos, contados en tiempo real",
openRequestsDesc: "Solicitudes de o para este contacto que no han sido cerradas, rechazadas o convertidas.",
openRequestsBasedOn: "{{open}} de {{total}} solicitudes siguen abiertas, contadas en tiempo real",
openInspectionsDesc: "Inspecciones vinculadas a este contacto que no se han completado.",
openInspectionsBasedOn: "{{open}} de {{total}} inspecciones vinculadas, contadas en tiempo real",
openJobsDesc: "Órdenes de trabajo sin terminar vinculadas explícitamente a este contacto. Es posible que el trabajo asignado únicamente a través de su cuenta de usuario no aparezca aquí.",
openJobsBasedOn: "{{open}} de {{total}} órdenes de trabajo vinculadas, contadas en tiempo real",
},
loadingLinkedWork: "Cargando trabajo vinculado",
linkedWorkErrorTitle: "No se pudo cargar el trabajo vinculado",
openWithName: "Abierto con {{name}}",
noOpenWork: "{{name}} no tiene trabajo abierto. Para darle una orden de trabajo, abre la orden de trabajo y toca Asignar.",
},
operational: {
tabsLabel: "Secciones del contacto",
tabs: {
overview: "Resumen",
assets: "Activos",
requests: "Solicitudes",
history: "Historial",
},
sharedAssetsTitle: "Activos compartidos",
sharedAssetsEmpty: "Aún no se han compartido activos. Comparta un activo para permitir que este contacto solicite inspecciones o proponga órdenes de trabajo.",
requestsTitle: "Solicitudes",
requestsEmpty: "Aún no hay solicitudes de este contacto.",
relatedWorkTitle: "Trabajo relacionado",
relatedWorkEmpty: "Aún no hay órdenes de trabajo ni inspecciones relacionadas.",
notesTitle: "Notas",
notesEmpty: "No hay notas sobre este contacto.",
assetLinksTitle: "Enlaces de activos",
assetLinksHelper: "Enlaces a nivel de registro (no es lo mismo que compartir espacio de trabajo).",
assetFallback: "Activo",
jobFallback: "Orden de trabajo",
workspaceAccess: "Acceso al espacio de trabajo",
permissionJobs: "Órdenes de trabajo",
permissionInspections: "Inspecciones",
permissionDocuments: "Documentos",
scheduleProposedAndScheduled: "Propuesto {{proposed}} · Programado {{scheduled}}",
scheduleScheduled: "Programado {{scheduled}}",
scheduleProposed: "{{proposed}} propuesto",
statusPrefix: "Estado {{status}}",
openRequestCount_one: "{{count}} solicitud abierta",
openRequestCount_other: "{{count}} solicitudes abiertas",
openAssetA11y: "Abrir activo {{name}}",
requestA11y: "Solicitud {{title}}",
jobA11y: "Orden de trabajo {{label}}",
inspectionA11y: "Inspección {{title}}",
shareAsset: "Compartir activo",
shareAssetA11y: "Elige un activo para compartir",
allRequests: "Todas las solicitudes",
allRequestsA11y: "Ver todas las solicitudes",
email: "Correo electrónico",
emailA11y: "Enviar correo al contacto",
invite: "Invitar",
inApp: "En la aplicación",
inviteA11y: "Invitar contacto",
shareContact: "Compartir contacto",
shareContactA11y: "Compartir contacto con el equipo",
openRequestCount_many: "{{count}} solicitudes abiertas",
},
linkCard: {
unlinkA11y: "Desvincular contacto",
otherRole: "Otro",
contactFallback: "Contacto",
},
inviteLanding: {
  acceptFailed: "No se pudo aceptar la invitación. Inténtalo de nuevo o pide una nueva a quien te la envió.",
  acceptFailedTitle: "No se pudo aceptar la invitación",
  accepted: "Listo. Todo lo que se comparte contigo aparece en Inicio.",
  expired: "Esta invitación ha caducado. Pide una nueva a quien te la envió.",
  desc: "{{name}}, te han invitado a AssetWRX. Inicia sesión para ver lo que se ha compartido contigo.",
},
};